export class ClassificationCModel{
  clasCCode ='' ;
  clasCName ='' ;
  clasCNotes ='' ;
  userID ='sa' ;
  compCode ='1' ;
  modifaiedDate = '2021-01-01';
}
